/* eslint-disable quotes */
export default {
  /* "key":"value" */

  /*App.js */
  "Notice.optimizedForChrome":
    "This website is optimized for Chrome. It is recommended to use Chrome.",

  /* PopUp */
  "PopUp.closeWindow.text": "Do not open this window for a day",
  "ClosePopupCheckbox.text": "Don't show this again",
  "ClosePopup.button.text": "Close",

  /* Antd - Popconfirm */
  "Popconfirm.cancelText": "Cancel",
  "Popconfirm.okText.delete": "Delete",
  "Popconfirm.okText.ok": "OK",

  /* Home.js */
  "Home.mainBanner.explain":
    "Selling even only 1 sticker is possible<br/>Go global with mojitok!",
  "Home.introduction.mojitokXstickerfarm":
    "It’s a sticker platform which provides the stickers to more than a trillion users worldwide<br/>through Samsung Galaxy series, Apple iMessage, Zalo and so on.",
  "Home.joinUs.title.01": "01  Simple Process",
  "Home.joinUs.subtitle.01":
    "The creator who is tired of long and<br/>complicated registration process",
  "Home.joinUs.description.01":
    "Registration will be done<br/>based on clear rules.<br/>Profit can be made <br/>with even just 1 sticker!",
  "Home.joinUs.title.02": "02  Worldwide",
  "Home.joinUs.subtitle.02":
    "The creator who wants to target <br/>the globally market",
  "Home.joinUs.description.02":
    "Sell your stickers global.<br/>Make sales to 1 trillion users worldwide.",
  "Home.joinUs.title.03": "03  Data-based",
  "Home.joinUs.subtitle.03":
    "The creator who needs data of<br/>what people want",
  "Home.joinUs.description.03":
    "Data of current interests of <br/>mojitok users provided.<br/>Usage data of individual sticker <br>can be checked.",

  "Home.howToUse.title": "How to use",
  "Home.howToUse.01": "Creator registration",
  "Home.howToUse.01.explain":
    "Enter the required information<br/>and register as a Creator.",
  "Home.howToUse.02": "Submit your stickers",
  "Home.howToUse.02.explain":
    "Choose a sticker and matching<br/>emotion tag and upload stickers.",
  "Home.howToUse.03": "Review",
  "Home.howToUse.03.explain":
    "Reviewing stickers will be done<br/>under clear rules and quick process.",
  "Home.howToUse.04": "Launch and Sell",
  "Home.howToUse.04.explain":
    "Stickers will be sold automatically<br/>after review is done!",
  "Home.button.signup": "Join stickerfarm",
  "Home.button.guideline": "stickerfarm Guideline",
  "Home.featured.title": "Featured Stickers",
  "Home.featured.popular": "current revenue<br/> of stickers",
  "Home.featured.popular.extraPoints": "Got the extra points",
  "Home.mojitok.explain":
    '<span style="display:flex;justify-content:flex-end">Chill chats with dope stickers</span><span style="display:flex;justify-content:flex-end">Send it and express your emotion</span>',

  /* Login.js */
  "Login.input.email": "Enter your e-mail",
  "Login.email.error.required": "Email is required",
  "Login.email.error.Type": "Email is not a valid email",

  "Login.input.password": "Password",
  "Login.password.error.required": "Password is required",

  "Login.error.invalid": "Invalid username/password.",

  "Login.forgotPassword": "* Forgot password?",
  "Login.signUp": "* Not a member? <u>Sign up now</u>",

  /* Signup.js */
  "Signup.headline": "Sign Up",

  "Signup.input.email": "Enter your e-mail",
  "Signup.email.error.required": "Email is required",
  "Signup.email.error.Type": "Email is not a valid email",

  "Signup.input.nickname": "Enter your nickname",
  "Signup.nickname.error.required": "Nickname is required",
  "Signup.nickname.error.minLength": "Nickname must be at least 3 characters",
  "Signup.nickname.error.maxLength": "Nickname cannot have more than 20 characters",
  "Signup.nickname.error.foramt":
    "Nickname must be registered in English, numbers.",
  "Signup.nickname.error.overlap":
    "This nickname has already been used.",
  "Signup.input.password": "Password",
  "Signup.password.error.required": "Password is required",
  "Signup.password.error.pattern":
    "Please set up a combination of eight or more alphanumeric characters,<br/>numbers, and special characters.",

  "Signup.input.confirm": "Confirm Password",
  "Signup.confirm.error.required": "Confirm Password is required",
  "Signup.confirm.error.check.password":
    "Two passwords that you enter is inconsistent",

  "Signup.terms.checkbox": "I agree",
  //signup checkbox modal
  "Signup.agreementModal.title.terms": "Terms and Conditions",
  "Signup.agreementModal.description.terms":
    'Before using or accessing any part of the service, please read attentively the terms and conditions of this License Agreement. Acceptance of the terms and conditions of this License Agreement is considered complete and irrevocable acceptance of all of the terms and of this License Agreement by the Creator.<br><br> <b>1. Definitions</b><br><br>1.1. "Contents" means digital content, such as images, emoticons, stickers, which may be used in internet communication services operated by StickerFarm contributed by you.<br><br>1.2  " Pack" means a unit of folder concept that can store and manage individual stickers.<br><br><b>2. Agreement to Terms and Conditions</b><br><br>2.1. All Creators shall use the Service in accordance with the terms stated in the Terms and Conditions. Creators may not use the Service unless they agree to the Terms and Conditions. Such agreement is valid and irrevocable.<br><br>2.2. Minors may use the Service only with consent from their parents or legal guardian. Furthermore, if Creators use the Service on behalf of, or for the purposes of a business enterprise, then that business enterprise shall also be deemed to have agreed to the Terms and Conditions. Such agreement is valid and irrevocable.<br><br>2.3. By actually using the Service, Creators are deemed to have agreed to the Terms and Conditions. Such agreement is valid and irrevocable.<br><br>2.4. If there are Separate Terms and Conditions for the Service, Creators also shall comply with such Separate Terms and Conditions as well as the Terms and Conditions.<br><br> <b>3. Account</b> <br><br>3.1. When you provide information to StickerFarm when using the Service, such information shall be true, accurate, complete, and kept up-to-date.  You are required to register your name, address, phone numbers, e-mail address, information necessary to process payments.<br><br>3.2 Stickerfarm does not keep your own information, and the information collected for the payment of the proceeds is discarded immediately after the payment.<br><br>3.3. StickerFarm may reject the registration of your account, suspend or delete your account, and/or terminate the agreement entered into between you and StickerFarm regarding the Service without giving prior notice to you for any reason.<br><br>3.4. Each account for the Service belongs solely to you. Unless otherwise set forth herein, you shall not transfer (including by inheritance) or lend their accounts to any third party. <br><br>3.5. " Creator " can request withdrawal from Sticker Farm at any time. Once the Creator is withdrawn, all of their personal information and content is deleted within 30 days. Deleted content cannot be restored. <br><br>3.6. Even if the "producer"requests withdrawal or suspension of content distribution, the user\'s purchased content can be provided before the user\'s service termination or withdrawal through the service provided through " StickerFarm".<br><br> <b>4. Payout</b> <br><br>4.1 StickerFarm shall pay to the Creator 30% of the revenue it receives from the sale and use of Content. <br><br>4.2 Creators’ earnings from sticker sales may be paid when the proceeds from the sale are more than $100 (hereinafter referred to as "minimum transfer amount"). The payment will be deposited into the account of the Creator within forty-five (45) days from the date StickerFarm receives the invoice from the Creator.<br><br> <b>5. Limitation of Liability</b><br><br>5.1. Creators must provide content to operators in the form required by stickerfarm, and the same content that is registered and sold on the same or similar service as this service is limited to upload.<br><br>5.2. StickerFarm does not expressly or impliedly guarantee that the Service (including the Program) are free from any de facto or de jure defects (including but not limited to stability, reliability, accuracy, integrity, effectiveness, fitness for particular purposes, security-related faults, errors, bugs, or infringements of rights). StickerFarm shall not be responsible for providing the Service to you without such defects. <br><br>5.3. StickerFarm shall not be liable for any damages incurred by you in relation to the use of the Service, including, but not limited to, any measures taken by StickerFarm in accordance with Terms and Conditions.<br><br>5.4. StickerFarm shall not be liable for any indirect, special, incidental, consequential or punitive damages (including but not limited to such damages that StickerFarm or Creators predicted or could have predicted) with respect to StickerFarm’s negligence (except for gross negligence), whether in contract, or tort or otherwise.<br><br>  <b>6. Copyrights and Warranties</b> <br><br>6.1. Legal Capacity: You warrant that You are 13 years of age or over and have the legal capacity to enter and accept this Agreement. By using this site, and/or registering for an account, You warrant that You are 13 years of age or older. <br><br>6.2. Tax Liability: You warrant that You shall be responsible for any income and all tax declarations as required in Your country of residence. StickerFarm shall not be held responsible for any tax issues pertaining to commissions paid out to You. <br><br>6.3. No Intellectual Property Right Infringement: You warrant that the Content that You are submitting to be licensed under StickerFarm are absent of any trademarks, service marks and logos and do not infringe the rights of any third party, including any intellectual property right. <br><br>6.4. No Immoral Content: Your Content does not involve any sensitive subject matters such as child abuse or exploitation, invasion of privacy or elements which are pornographic, offensive, politically endorsing, racist, ethnically or culturally offensive, obscene or indecent, sexually explicit, immoral, defamatory, intrusive of privacy or illegal; or which endorses violence or acts of terrorism, is discriminatory towards race, gender, religion, faith or sexual orientation. <br><br>6.5. Right to Grant: You represent and warrant that You have all unconditional and irrevocable authority, right, title and ownership in granting all the rights in this Agreement to StickerFarm in relation to Your Content. <br><br>6.6. Creation Expenses: You represent and warrant that other than the commissions, there are no other fees, expenses, claims, damages or royalties payable or which may be payable to You (or any person involved in the creation of the Content uploaded by You) (Creation Expenses) by StickerFarm  and the StickerFarm  Parties, as a result of the licensing or use of the Content pursuant to the terms and conditions of this Agreement, and that any entitlement to Creation Expenses however and whenever arising is hereby waived by You unconditionally. You further represent and warrant that all Creation Expenses payable to persons involved in the creation of the Content uploaded by You have been paid by You in full and that if, for any reason, such Creation Expenses remain outstanding or arise, You shall bear full and sole responsibility. <br><br>6.7. Virus/Malware: You warrant and represent that You will not introduce or transmit to the Sites (and Your Content do not contain) any material or program of any kind that contains any virus, Trojan horse, spyware, adware, malware, bot, time bomb, worm, or other harmful or malicious component, which or might overburden, impair or disrupt the Sites or servers or networks forming part of, or connected to, the Sites, or which does or might restrict or inhibit any other creator\'s use and enjoyment of the Sites. <br><br>6.8. True Information: You warrant that all registration information, documents and identification provided by You are true, accurate, up to date and not misleading, and that You shall update such information to the Sites/StickerFarm as changes occur. <br><br>6.9. Intellectual Property Right Duty: You represent and warrant that Your Content does not, in any way and in any territory worldwide, infringe intellectual property right. You agree that You may not upload any Content which infringes any Intellectual Property Right and You have the duty and obligation to notify StickerFarm of any such infringement (or possible infringement) and to take all steps to prevent any infringement of intellectual property right. StickerFarm reserves the right to remove from the Site and the Distribution Network any Content which infringes (or which StickerFarm believes may infringe) any Intellectual Property Right with or without notice or reference to You.<br><br> <b>7. Restrictions</b><br><br>Creators shall not engage in the following when using the Service.<br><br>7.1 Morality and ethics<br><br>     &nbsp;&nbsp;&nbsp;&nbsp;1. Contents that are out of sync with the public, such as crime, violence, or sexual expression            <br><br>     &nbsp;&nbsp;&nbsp;&nbsp;2. Association with smocking and contents that encourage smoking            <br><br>     &nbsp;&nbsp;&nbsp;&nbsp;3. Content that contains antisocial content<br><br>     &nbsp;&nbsp;&nbsp;&nbsp;4. Contentious content<br><br>  &nbsp;&nbsp;&nbsp;&nbsp;5. Content that includes abuse and abuse<br><br>  &nbsp;&nbsp;&nbsp;&nbsp;6. Contents that are interpreted as attacks on specific nationalities, religions, cultures, or groups, or that may cause displeasure <br><br>7.2 Propose such as business and advertising promotion<br><br>     &nbsp;&nbsp;&nbsp;&nbsp;1. Content that is designed to benefit third parties other than the provider or that is intended for service and advertising or promotion.<br><br>     &nbsp;&nbsp;&nbsp;&nbsp;2. Content created by the enterprise for advertising and promotion of brands and services.<br><br>    &nbsp;&nbsp;&nbsp;&nbsp;	3. Contents by personal and enterprise collaboration.<br><br>     &nbsp;&nbsp;&nbsp;&nbsp;4. Content that includes advertising copy. <br><br>7.3Copyright, infringement of portrait rights and allegations of plagiarism        	<br><br>&nbsp;&nbsp;&nbsp;&nbsp;1. Content that may infringe copyright or portrait rights of others\' products or Plagiarized  <br><br><b>8. Governing Law and Dispute Resolution</b> <br><br>This Agreement shall be governed by, and shall be construed in accordance with, the laws of South Korea. Any dispute, controversy or claim arising out of or relating to this Agreement, including validity, invalidity, breach or termination thereof, shall be settled by Seoul Central District Court. (Subject to exceptional consultation) <br><br><b>9. Language</b> <br><br>This Agreement was originally written in Korean and was subsequently translated into other languages. The fidelity of subsequent translations cannot be guaranteed. In case of inconsistency between the Korean and the translated version, the Korean version shall prevail. <br><br><b>10. Modification</b> <br><br>10.1. Operators may change these terms or separate terms and conditions if necessary.<br><br>10.2. If a business operator changes the terms and conditions, it shall be notified from the 7th day before the effective date to the effective date in the appropriate place on the website of the service, and the changed terms and conditions shall take effect from the effective date. However, if you change the terms and conditions against the producer, you will be notified individually to the e-mail address that the producer notified to the operator for at least 30 days prior grace period.<br><br>10.3. Continued use of the Service after the date of application without notice of intent within the notification period of the Terms of Use or the Separate Terms of Use shall be deemed irrevocable to the modified Terms of Use or the Separate Terms of Use.<br><br>10.4. Creators are encouraged to consult the latest version of the Terms of Use regularly when using the Service.  <br><br> Last Updated: December 4th, 2020<br> ',
  "Signup.agreementModal.title.privacy": "Privacy Statement",
  "Signup.agreementModal.description.privacy":
    '<b>Privacy Policy</b><br/><br/>Platfarm Inc. (the "Company") collects, uses and provides personal information based on the user\'s consent,<br/>"We actively guarantee the rights of users (personal information self-determination)." The Company complies with the relevant laws, regulations, and guidelines of the Republic of Korea to be complied with by the providers of information and communication services. "Personal Information Processing Policy" means the guidelines that the company must adhere to so that users can safely use the service by protecting their valuable personal information. This Privacy Policy applies to the Stickerfarm.<br/><br/><br/><b>Collecting personal information</b><br/><br/>We collect the minimum amount of personal information we need to provide our services.<br/><br/>[Stickerfarm Account]<br/>Necessary<br/>Email, name (nickname) <br/><br/>Select (Korea only)<br/>Bank account information, Address, Resident registration number<br/><br/><br/>[Service center]<br/>Email, name (nickname) <br/><br/><br/><b>Here\'s how to collect your personal information</b><br/><br/>When collecting personal information, we must notify the user in advance and seek consent, and collect personal information through the following methods.<br/><br/>●	When a user agrees to collect personal information and enters information directly in the course of membership and service use.<br/>●	Personal information required for payment at settlement.<br/>●	Web page during consultation process through customer center and e-mail, etc.<br/><br/><br/><b>Use of personal information</b><br/><br/>It is used for membership management, service provision and improvement, and new service development.<br/>At the time of signing up for membership or using the service, we collect the minimum personal information necessary for providing the service through the homepage or individual applications or programs.<br/><br/>●	Develop new services, provide various services, process inquiries or complaints, and deliver announcements.<br/>●	When using paid service, transfer of contents, settlement of payments.<br/>●	Preventing and sanctioning acts that interfere with the smooth operation of services (including the theft of accounts and illegal use).<br/>●	Use for event/event participation, marketing, and advertising.<br/>●	Voice command recognition and personalization service.<br/>●	Voice command recognition and personalization service.<br/>●	Statistics on service use history, access frequency, and service utilization, the establishment of service environment in terms of privacy protection, provision of customized service, utilization of service improvement.<br/><br/><br/><b>Providing personal information</b><br/><br/>Stickerfarm will not provide your personal information to any third party unless you have your consent or the law provides.<br/><br/><br/><b>Destruction of personal information</b><br/><br/>Personal information will be destroyed without delay when the purpose of collection and use is achieved. Procedures and methods are as follows.<br/><br/><b>Securely delete electronic files from recovery and playback.</b><br/><br/>In Korea, the information related to the payment is immediately destroyed as soon as the act is completed.<br/><br/><br/><b>What is our privacy policy?</b><br/><br/>For any inquiries, complaints, advice, or any other information related to the use of the service, please contact the person in charge of personal information protection and the relevant department. We will do our best to listen to your voice and give you a quick and sufficient response.<br/><br/>●	Chief Privacy Officer Name : Hyo Sub Lee <br/>●	Tel : 82-070-7560-7002<br/>●	Email : mojitok@platfarm.net<br/><br/><br/>If our privacy policy changes<br/>You may modify your privacy policy for purposes of reflecting changes in law or services.<br/><br/><b>If the privacy policy changes,</b><br/><br/> the stickerfarm publishes the changes, and the modified privacy policy takes effect on the date of posting.<br/>However, we will notify you at least 30 days in advance of any significant change in the user\'s rights, such as changes in the items of personal information collected or the purpose of use.<br/><br/><br/>Last Updated: October 22nd, 2019',

  "Signup.btn": "Sign up",

  //signup notification
  "Signup.noti.terms.check":
    "Please read and agree to the Terms and Conditions 📝",

  //signup success Modal
  "Signup.modal.btn": "OK",
  "Signup.modal.title": "Check your E-mail",
  "Signup.modal.explain.underline": "Didn&#39;t receive the E-mail?",
  "Signup.modal.explain": "Please check your E-mail address or spam.",

  /* Reset.js */
  "Reset.headline": "Reset Password",

  "Reset.input.email": "Enter your e-mail",
  "Reset.email.error.required": "Email is required",
  "Reset.email.error.Type": "Email is not a valid email",

  "Reset.btn": "Send",

  //Reset success Modal
  "Reset.modal.btn": "OK",
  "Reset.modal.title": "Check your E-mail",
  "Reset.modal.explain.underline": "Didn&#39;t receive the E-mail?",
  "Reset.modal.explain": "Please check your E-mail address or spam.",

  /** package status values */
  "PkgStatus.creating": "Creating",
  "PkgStatus.underReview": "Pending",
  "PkgStatus.approved": "Approved",
  "PkgStatus.approved.mypackage": "Released",
  "PkgStatus.unapproved": "Rejected",
  "PkgStatus.editing": "Editing",
  "PkgStatus.discontinue": "Release Terminated",

  /* Upload */
  "Progress.numberOfSticker": "{count} stickers have been uploaded.",
  "Upload.packages.serverError":"Something went wrong, Please try rater!!",

  /* Upload - navigation */
  "Upload.packages.nav.packageCreation": "New Pack",
  "Upload.packages.nav.packagesInProgress": "Pack Editing",
  "Upload.packages.nav.packagesOfReviewed": "Approval Status",
  "Upload.packages.goto.mypage": "Go to Pack Editing page",
  "Upload.packages.goto.reviewedpage": "Go to Approval Status page",

  /* Upload - pack type */
  "Upload.packType": "Pack Type",
  "Upload.packType.PLUS": "Plus Pack",
  "Upload.packType.BASIC": "Basic Pack",
  "Upload.movingStatus.ANIMATED": "Animated Sticker",
  "Upload.movingStatus.STILL": "Still Image Sticker",

  /* Upload - Pack KeyText Form */
  "package.input.keyword.placeholder": "Enter the keyword",

  /* Upload - creation-package : select package type */
  "Upload.PkgCreation.selectPackType.headline": "New Pack",
  "Upload.PkgCreation.selectPackType.headline.undefined": "Pack Creation",
  "Upload.PkgCreation.selectPackType.headline.PLUS": "Plus Pack Creation",
  "Upload.PkgCreation.selectPackType.headline.BASIC": "Basic Pack Creation",
  "Upload.PkgCreation.selectPackType.guide":
    "Are you curious about the Plus Pack and Basic Pack?",
  "Upload.PkgCreation.selectPackType.animatedStickerButton":
    "Animated<br/>Sticker",
  "Upload.PkgCreation.selectPackType.stillStickerButton":
    "Still Image<br/>Sticker",
  "Upload.PkgCreation.selectPackType.caution.1":
    "Once submitted, the pack type cannot be changed.",
  "Upload.PkgCreation.selectPackType.caution.2":
    "The screening process for plus pack and basic pack is the same.",
  "Upload.PkgCreation.selectPackType.caution.3":
    "The screening period for plus pack and basic pack is the same.",
  "Upload.PkgCreation.selectPackType.PLUS.title": "Plus Pack",
  "Upload.PkgCreation.selectPackType.PLUS.caption":
    "Expansion of more sales channels!",
  "Upload.PkgCreation.selectPackType.PLUS.description":
    "<strong>24</strong> stickers and <strong>above</strong>",
  "Upload.PkgCreation.selectPackType.BASIC.title": "Basic Pack",
  "Upload.PkgCreation.selectPackType.BASIC.caption":
    "You can submit a single sticker!",
  "Upload.PkgCreation.selectPackType.BASIC.description":
    "<strong>Fewer</strong> than <strong>24</strong> stickers",

  /* Upload - creation-package : create package */
  "Upload.PkgCreation.createPack.thumbnail.title": "Pack Thumbnail",
  "Upload.PkgCreation.createPack.packType": "Pack Type",
  "Upload.PkgCreation.createPack.packType.PLUS": "Plus Pack",
  "Upload.PkgCreation.createPack.packType.BASIC": "Basic Pack",
  "Upload.PkgCreation.createPack.packType.undefined": "No Type",
  "Upload.PkgCreation.createPack.packType.animated": "Animated Sticker",
  "Upload.PkgCreation.createPack.packType.still": "Still Image Sticker",
  "Upload.PkgCreation.createPack.packName": "Pack Name",
  "Upload.PkgCreation.createPack.packDescription": "Pack Description",
  "Upload.PkgCreation.createPack.packDescription.caution":
    "Please check the pack name and description for typos and morally or ethically inappropriate words.",
  "Upload.PkgCreation.createPack.packInfoLanguage": "Language",
  "Upload.PkgCreation.createPack.packInfoLanguage.choice": "Add language",
  "Upload.PkgCreation.createPack.packInfoLanguage.guide":
    "Add the name and description of the pack in various languages. The added information is available to users in countries where those packs are exposed and sold.",
  "Upload.PkgCreation.createPack.packLanguage.selection":
    "Pack Language Selection",
  "Upload.PkgCreation.createPack.packLanguage.imageOnly": "No Text",
  "Upload.PkgCreation.createPack.packLanguage.include": "With Text",
  "Upload.PkgCreation.createPack.packLanguage.caution":
    "If any sticker in the pack includes text, please select the language.",
  "Upload.PkgCreation.createPack.packLanguage.guide.title": "‘No text’ case",
  "Upload.PkgCreation.createPack.packLanguage.guide.description.1":
    "1. If it consists of images only",
  "Upload.PkgCreation.createPack.packLanguage.guide.description.2":
    "2. When using special symbols recognized as images",
  "Upload.PkgCreation.createPack.packKeyword": "Pack keyword",
  "Upload.PkgCreation.createPack.packKeyword.caution":
    "Please list the topic and style of the pack as keyword tags for the pack search. You can register up to 10<br>keywords. Keywords that are not related to the pack may be excluded from future searches.",
  "Upload.PkgCreation.createPack.savebutton": "SAVE",

  "Upload.PkgCreation.createPack.message.thumbnailExt":
    " The pack thumbnail image should be a PNG file.",

  "Upload.PkgCreation.createPack.popconfirm.message":
    "<div>If you change pack language, Sticker tag & language,<br> you already did, will be Reset. 😢<br>Do you want to change Pack Language?</div>",
  'Upload.PkgCreation.createPack.langchange.error':
    'You can’t change language when sticker is approved.',
  "Upload.PkgCreation.createPack.popconfirm.ok": "Ok",
  "Upload.PkgCreation.createPack.popconfirm.cancel": "No",

  /* Upload - progress-package : package list */
  "PkgInProgress.headline": "Pack Editing",
  "PkgInProgress.not.pkgInProgress":
    "There are no pack in progress.<br/>Click on the button below to upload a new pack!",
  "PkgInProgress.btn.createNewPkg": "+ Create a new pack",

  "PackageList.modal.btn": "OK",
  "PackageList.modal.title": "Caution!",
  "PackageList.modal.description":
    "Please submit characters using personal creation or gained licenses.📤",
  "PackageList.modal.distribute.info":
    "After selecting<br/>1. Pack Info > 2. Sticker Upload > 3. Tag Selection > 4. Summary <br/> It will be distributed as soon as you click <strong>Submit for Review</strong>.",
  "PackageList.modal.distribute.caution":
    "After pressing 'Submit for Review', you cannot modify it!🙅<br/>Please check carefully and request!🙏🙏🙏",

  "PackageItem.available": "under review",

  /* Upload - progress-package : nav */
  "Upload.packagesInProgress.step.info": "Pack Info",
  "Upload.packagesInProgress.step.sticker-upload": "Sticker Upload",
  "Upload.packagesInProgress.step.select-tag": "Tag Selection",
  "Upload.packagesInProgress.step.confirm": "Summary",

  "Upload.packagesInProgress.nav.packageInfo": "1. Pack Info",
  "Upload.packagesInProgress.nav.stickerUpload": "2. Sticker Upload",
  "Upload.packagesInProgress.nav.selectTag": "3. Tag Selection",
  "Upload.packagesInProgress.nav.confirm": "4. Summary",

  //2. PackageInfo.js
  "PackageInfo.tag": "Create a pack ",
  "PackageInfo.cover.text": "Pack Thumbnail",
  "PackageInfo.png.size": "Image must be a 250x250px PNG file",
  "PackageInfo.package.name": "Pack Name",
  "PackageInfo.package.name.pack": "Pack Name",
  "PackageInfo.package.name.local": "Pack Name (Local)",
  "PackageInfo.package.name.local.explanation":
    "You can also put the pack name here in your local language.",
  "PackageInfo.package.description": "Description",
  "PackageInfo.package.description.pack": "Pack Description",
  "PackageInfo.package.info.explanation":
    "Please check Pack Name and Description for any typing errors or morally and ethically inappropriate words.",
  "PackageInfo.package.btn": "Save",

  "PackageInfo.package.language": "Language Selection",
  "PackageInfo.package.language.explain":
    "You can choose whether or not to include text in your creations, <br/>and if you have text, you can select that language.<br/>For more information, please refer to the instructions on how to use Stickerfarm.",
  "PackageInfo.package.languageError.explain":
    "This pack requires a language selection setting.",
  "PackageInfo.package.language.onlyImage": "No text",
  "PackageInfo.package.language.withText": "With text",
  "PackageInfo.package.language.list.0": "English",
  "PackageInfo.package.language.list.1": "Korean",
  "PackageInfo.package.language.list.2": "Chinese",
  "PackageInfo.package.language.list.3": "Japanese",
  "PackageInfo.package.language.list.4": "Vietnamese",
  "PackageInfo.package.language.list.5": "Spanish",
  "PackageInfo.package.language.list.6": "Arabic",
  "PackageInfo.package.language.list.7": "German",
  "PackageInfo.package.language.list.8": "French",
  "PackageInfo.package.language.list.9": "Italian",
  "PackageInfo.package.language.list.10": "Portuguese",
  "PackageInfo.package.language.list.11": "Russian",

  "PackageInfo.noti.fileSize": "The image size is too big. 😨",
  "PackageInfo.noti.thumbnail": "Please give your pack a thumbnail image. 🌈",
  "PackageInfo.noti.thumbnailExt":
    "The pack thumbnail image should be a PNG file.",
  "PackageInfo.noti.input.name": "Please give your pack a name. ✏️",
  "PackageInfo.noti.english.name": "Please enter the pack name in English. 😢",
  "PackageInfo.noti.name.minLength":
    "The pack name must have more than 3 characters. 😢",
  "PackageInfo.noti.name.maxLength":
    "The pack name cannot have more than 40 characters. 😢",
  "PackageInfo.noti.multiLangInfo.name.minLength":
    "Pack name must be at least 1 characters. 😢",
  "PackageInfo.noti.multiLangInfo.name.maxLength":
    "The pack name cannot have more than 40 characters. 😢",
  "PackageInfo.noti.multiLangInfo.description.minLength":
    "Pack description must be at least 1 characters. 😢",
  "PackageInfo.noti.input.description":
    "Please provide a description for your pack.📒",
  "PackageInfo.noti.english.description":
    "The description should be written in English. 😢",
  "PackageInfo.noti.languageSelection.input.language":
    "Please select a language.😢",
  "PackageInfo.noti.languageSelection.input.keyText.notValid":
    "Pack keyword can be entered up to 10 in English and numbers. The space between keywords is allowed up to 2 times.",
  "PackageInfo.noti.languageSelection.input.keyText.noInput":
    "Pack keyword is not entered.\nPlease enter more than one pack keyword.✍️",
  "PackageInfo.noti.editPackage":
    "Please modify images or information in this pack. ",
  "PackageInfo.noti.editPackage.error":
    "There are images or information that have not been modified in this pack. Please make modifications and complete by pressing the save button.",
  "PackageInfo.noti.editPackage.error.title": "Please modify pack information.",
  "PackageInfo.noti.editPackage.error.description":
    "Some information has not been modified.\nPress Save button after editing to complete saving.",
  "PackageInfo.noti.savePackage.error.title": "Save pack information!",
  "PackageInfo.noti.savePackage.error.description":
    "Pack information must be saved before you can move on to the next step.\nClick on the ‘Save’ button to complete this step.",
  "PackageInfo.noti.savePackage.fail":
    "The information of the pack I entered was not saved. Please try again.",

  "PackageInfo.noti.savePackage.title": "Pack Info complete!",
  "PackageInfo.noti.savePackage.description":
    "The pack information that was entered is now saved. Please move on to the sticker upload stage.",
  "PackageInfo.error.nameOverlap":
    "This pack name has already been used.",
  /* Upload - progress-package : 1. package info */
  //guide & guide modal
  "PackageInfo.guide.modal.btn": "Thumbnail Production Guide",
  "PackageInfo.guide.modal.title": "Thumbnail Production Guide",
  "PackageInfo.guide.modal.explain":
    '1. An image file must be 250 x 250 (px) and below 500KB.<br/>2. Image must have a transparent background and resolution of 72dpi.<br/>3. There must be a clear margin of 20 px on all sides.<br>4. Pack Thumbnail should be still image format(PNG).<br/><p style="margin: 10px 0px">For more guide lines and limitations, visit <u><a style="color:#a202ff" href="/guide/howToUse" target="_blank">Production Guide page</a></u>.</p>',

  /* Upload - progress-package : 2. sticker upload */
  //guide & guide modal
  "StickerUpload.guide.title":
    "Click on Sticker Upload to upload the sticker images.",
  "StickerUpload.guide.title.PLUS": " You may upload 24 files or more.",
  "StickerUpload.guide.title.BASIC": " You may upload up to 23 files.",
  "StickerUpload.guide.modal.btn": "Production Guide",
  "StickerUpload.guide.explain":
    'Make the image file exactly 618x618(px) in dimension and under 500KB in size. It must have a transparent background and a resolution of 72 dpi. There should be a clear margin of 20 px on all sides.<br/>Please refer to the <a style="color:#a202ff" href="/guide/howToUse" target="_blank" rel="noopener noreferrer">Production guide page</a> for further detail.<br>A <span style="color:#FFBF00">yellow</span> border indicates a sticker that requires modification.  A <span style="color:#a202ff">purple</span>  border means the sticker has been approved',
  "StickerUpload.guide.modal.title": "Sticker Production Guide",
  "StickerUpload.guide.modal.explain":
    '<ol style="padding-inline-start: 13px;"><li>File must be 618x618px and below 500KB.</li><li>Image must have a transparent background and resolution of 72dpi.</li><li>There must be a clear margin of 20px on all sides.</li><li> When saving a GIF, set matte settings to white or none,<br/>and check Transparency >  “Diffusion Transparency Dither”. </li></ol><p style="margin: 10px 0px">For more guide lines and limitations, visit <u><a style="color:#a202ff" href="/guide/animatedSticker" target="_blank">Production Guide page</a></u>.</p>',

  "StickerUpload.stickerCount": "Number of stickers",
  "StickerUpload.stickerCount.desc.PLUS":
    '<span style="color:#ff6060">*</span><span style="color:rgba(0, 0, 0, 0.38); font-size:14px; line-height:22px; letter-spacing: -0.5px">24 stickers and above</span>',
  "StickerUpload.stickerCount.desc.BASIC":
    '<span style="color:#ff6060">*</span><span style="color:rgba(0, 0, 0, 0.38); font-size:14px; line-height:22px; letter-spacing: -0.5px">Fewer than 24 stickers</span>',

  "StickerUpload.tag": "Select file to Upload ",
  "StickerUpload.dragger.explain": "Drag and drop <br/>or click to upload",
  "StickerUpload.dragger.format": "File format: PNG, GIF",

  "StickerUpload.select.explain": "Sticker Upload",

  "StickerUpload.noti.stickerPixel":
    "Image pixel does not match. (Only 618 x 618px) 😵",
  "StickerUpload.noti.stickerFormat":
    "File format is incorrect. (PNG, GIF only) 😑",
  "StickerUpload.noti.stickerSize": "File size is within 500 KB. 📁",
  "StickerUpload.noti.uploadSuccess": "Sticker Upload complete",
  "StickerUpload.noti.deleteSuccess": "Sticker Delete complete",

  "progressPkg.sticker.delete": "Are you sure you want to delete it? 🤔",

  /* Upload - progress-package : 3. Select Tag */
  //guide & guide modal
  "SelectTag.guide.addTag":
  "Add tag",
  "SelectTag.guide.title":
    "Click a sticker to select its corresponding emotion tag and language.",
  "SelectTag.guide.modal.btn": "Tag Guide",
  "SelectTag.guide.explain":
    "A <span style='color:#5fffaf'>green</span> border means emotion tagging and language selection on that sticker are complete, while a <span style='color:#ff6060'>red</span> border means they are incomplete. A <span style='color:#FFBF00'>yellow</span> border means the sticker has been rejected after review and requires modification. A <span style='color:#a202ff'>purple</span>  border means the sticker has been approved <br/>Please complete tagging for all stickers to submit the pack.",
  "SelectTag.guide.modal.title": "Sticker Tag Guide",

  "SelectTag.guide.modal.explain.title": "🔍 Tag Selection",
  "SelectTag.guide.modal.explain.right":
    '<ul class="select-tag-guide-ul"><li>An emotion or situation that can be inferred from the sticker</li><li>The first tag that comes to mind when looking at the sticker</li><li>A tag that intuitively matches<br/>the sticker</li></ul>',
  "SelectTag.guide.modal.explain.wrong":
    '<ul class="select-tag-guide-ul"><li>An emotion or situation that can not be inferred from the sticker</li><li>An element that has nothing to do with the sticker’s emotion or situation</li></ul>',

  "SelectTag.guide.modal.caution.title":
    "⚠️ Things to note when selecting tags",
  "SelectTag.guide.modal.caution.description":
    '<ul style="list-style-type:decimal; padding-left:15px; margin-bottom:0px;"><li>Each sticker can have <strong>a minimum of 1 tag and a maximum of 3 tags</strong> selected.</li><li>If <strong>tags do not match the emotion or situation presented,</strong> the sticker <strong>may be rejected.</strong></li><li>Stickers without tags selected cannot be submitted.</li></ul>',

  "SelectTag.guide.link.message":
    'For more information about how to select tags, visit <a href="/guide/selectTags" target="_blank">How to Select Tags page</a>.',

  "SelectTag.guide.modal.exmaple.title": "🏷 Tag selection examples",
  "SelectTag.guide.modal.exmaple.1":
    "<div>An emotion or situation that can be inferred<br/>from the sticker</div><div>A background element that is related <br/>to the emotion or situation of the sticker</div>",
  "SelectTag.guide.modal.exmaple.2":
    '<div>An emotion or situation that can be inferred <br/>from the sticker</div><div style="margin-top:23px; color:#ff6060;">An emotion or situation that can not be <br/>inferred from the sticker</div>',
  "SelectTag.guide.modal.exmaple.3":
    '<div>An emotion or situation that can be inferred <br/>from the sticker</div><div style="color:#ff6060;">An emotion or situation that can not be <br/>inferred from the sticker</div>',
  "SelectTag.guide.modal.exmaple.4":
    '<div>A tag that intuitively matches the sticker</div><div style="margin-top:5px; color:#ff6060;">An element that has nothing to do with the <br/>sticker’s emotion or situation and included in <br/>the sticker as a background</div>',
  "SelectTag.taginfo.tag": 'Tag',
  "SelectTag.taginfo.lang": 'Language',
  "SelectTag.modal.title": "Select tags and language",
  "SelectTag.modal.sticker": "Sticker",
  "SelectTag.modal.selectedTags": "Selected tags",
  "SelectTag.modal.maxTags": "Maximum of 3 tags",
  "SelectTag.modal.rightTagGuide.title":
    "⚠️ Why is it important to choose the right tag?",
  "SelectTag.modal.rightTagGuide.description":
    "<p>Stickers are recommended to our users according to your selected tags, hence the exposure and usage of each sticker is dependent on the accuracy of the tags. Search by keyword or by category to choose appropriate tags for your sticker!</p><br/><p>💡If you are struggling to find a tag from our list that matches your sticker,<br/> it may be as difficult to find users who resonate with your sticker. 😂<br/>Before producing your sticker, browse our tag list to understand what kind of stickers users often look for.</p>",

  "SelectTag.modal.tagSelection.title": "1. Tag Selection",
  "SelectTag.modal.tagSelection.description":
    'If The Sticker\'s Emotion, Situation, And Tag Do Not Match, The Proposal Will Be Rejected For Reasons Of Non-Approval. Please Refer To Guide > "How To Select Tags"And Select A Tag.',
  "SelectTag.modal.keywordSearch.title": "Keyword Search",
  "SelectTag.modal.keywordSearch.description":
    "You Can Search For Keywords That Match Stickers And Select Tags!",
  "SelectTag.modal.categorySearch.title": "Category Search",
  "SelectTag.modal.categorySearch.description":
    "You Can Choose A Tag That Matches The Sticker By Referring To The Emoji Category!",

  "SelectTag.modal.languageSelection.title": "2. Language Selection",
  "SelectTag.modal.languageSelection.description":
    "If your sticker includes text in the image, select the language.",

  "SelectTag.modal.answerSticker.title": "Tag Verification",
  "SelectTag.modal.answerSticker.description":
    "Compare <span style='font-weight: 700'> the uploaded sticker and the example sticker </span>to make sure the tag is selected correctly!! <br>If the tag selection is not correct, the pack may not be sold, so please check carefully.",
  "SelectTag.modal.answerSticker.selectedSticker": "Selected Sticker",
  "SelectTag.modal.answerSticker.selectedTag": "Selected Tag",
  "SelectTag.modal.answerSticker.selectedAnswerStickers":
    "Selected correct answer sticker",
  "SelectTag.modal.btn": "Save",
  "SeleteTag.modal.RefuseSticker":"Example of wrong tagged sticker",
  "SeleteTag.modal.RefuseSticker.explain":"    -  Inexact tag of sticker\n    -  Tag's meaning do not come out directly",
  "SelectTag.modal.answerSticker.select.description":"Details of selected tag",

  /* Upload -  EmojiSearchInputWindow */
  "EmojiSearchInputWindow.inputSearchText.placeholder": "Input search text.",

  /* Upload - progress-package : 4. summary */
  "PkgConfirm.noti.tagsNotExist":
    "Sticker tagging is not finished. Please complete tagging.",
  "PkgConfirm.noti.editingIsNotComplete":
    "There are rejected stickers still remaining that should be modified/deleted.\n Please finish the modification/deletion of rejected stickers.",
  "PkgConfirm.noti.PLUS.notEnoughStickerNumber":
    "Oops! For a plus pack, you may upload 24 stickers or more. Please upload at least 24 stickers.",
  "PkgConfirm.noti.BASIC.toManySticker":
    "Oops! The maximum number of Basic sticker pack is limited to 23. Please submit your sticker below 24. Otherwise, you can upload it for Plus pack. We are allowing 24 or above stickers for Plus pack.",
  "PkgConfirm.btn": "Submit for Review",
  "PkgConfirm.popconfirm.message":
    "<b>Final Check Before Submission</b><div>Before pressing the submit button, please check if there is<br/>anything to modify! After the sticker pack is approved, you<br/>cannot modify the pack description, stickers, tags, etc.</div>",
  "PkgConfirm.popconfirm.ok": "Submit",
  "PkgConfirm.popconfirm.cancel": "I want to check again",

  "PkgConfirm.modal.success.title": "Upload complete",
  "PkgConfirm.modal.success.subTitle": "Congratulations!",
  "PkgConfirm.modal.success.description":
    "Congratulations! Your sticker pack has been\nsubmitted. The results of the sticker pack review will\nbe sent after the review is done.",
  "SelectEmotion.modal.success.ok": "Confirm",

  "PkgConfirm.modal.fail.title": "Upload fail!",
  "PkgConfirm.modal.fail.description":
    "Oops! The sticker pack has not been submitted. please try again.",
  "PkgConfirm.modal.fail.ok": "Confirm",

  /** Upload - packages-of-reviewed : ReviewedPkgList.js */
  "ReviewedPkgList.table.thumbnail": "Thumbnail",
  "ReviewedPkgList.table.pkgName": "Pack name",
  "ReviewedPkgList.table.packType": "Pack Type",
  "ReviewedPkgList.table.packTypeName": "Pack type & name",
  "ReviewedPkgList.table.packType.BASIC": "Basic Pack",
  "ReviewedPkgList.table.packType.PLUS": "Plus Pack",
  "ReviewedPkgList.table.reviewRequestedAt": "Date\nsubmitted",
  "ReviewedPkgList.table.approvedAt": "Date\napproved",
  "ReviewedPkgList.table.status": "Approval\nstatus",
  "ReviewedPkgList.btn.unapproved": "Why?🤔",
  "ReviewedPkgList.headline": "Approval Status",
  "ReviewedPkgList.guide.title":
    "You can check the approval status of pack that have been submitted for review",
  "ReviewedPkgList.guide.description":
    "You can check rejection details by clicking Why? button of the pack.<br>Approved packs may be immediately released for use and automatically deleted from this page after 15 days.",

  /** PackageInfo.js */
  "PackageInfo.type": "Pack Type",
  "PackageInfo.title": "Pack information",
  "PackageInfo.name.en": "Pack Name(English)",
  "PackageInfo.name.local": "Pack Name(Local)",
  "PackageInfo.description": "Pack Description<br>(English)",
  "PackageInfo.status": "Status",
  "PackageInfo.lang": "Pack Language",
  "PackageInfo.title.additional": "Pack information (Additional)",
  "PackageInfo.keyText": "Pack keyword<br>(English)",

  /** StickerInfo.js */
  "StickerInfo.title": "Sticker list",
  "StickerInfo.text.tag": "Tag",
  "StickerInfo.text.language": "Lang",
  "StickerInfo.unapproved.alert.title.delete": "Reasons for rejection - delete",
  "StickerInfo.unapproved.alert.title.edit": "Reasons for rejection - edit",

  /** PkgAndStickerInfo.js */
  "PkgAndStickerInfo.headline.creating": "Draft Pack",
  "PkgAndStickerInfo.headline.underReview": "Pending Pack",
  "PkgAndStickerInfo.headline.approved": "Approved Pack",
  "PkgAndStickerInfo.headline.unapproved": "Rejected Pack",
  "PkgAndStickerInfo.headline.editing": "Editing in progress",
  "PkgAndStickerInfo.headline.discontinue": "Release terminated",

  "PkgAndStickerInfo.pkgDelete.message":
    '<div><span class="caution-mark">*</span> If all stickers in the pack fall under Reject Reasons C-G, we recommend deleting the pack.</div>',
  "PkgAndStickerInfo.pkgDelete.popconfirm.message":
    "<b>Delete Rejected Pack</b><div class=\"deleted-package-popconfirm\">Click the 'Delete' button below to delete the pack.<br/>Please make and submit a new pack.</div>",

  "PkgAndStickerInfo.btn.pkgDelete": "Delete the Pack",
  "PkgAndStickerInfo.btn.resubmit": "Edit to resubmit",

  /* Guide.js */
  //0. guide navigation
  "Guide.nav.packType": "How to make",
  "Guide.nav.BASIC": "Basic Pack",
  "Guide.nav.PLUS": "Plus Pack",
  "Guide.nav.movingStatus": "Sticker Type",
  "Guide.nav.stillImageSticker": "Still Image Sticker",
  "Guide.nav.animatedSticker": "Animated Sticker",
  "Guide.nav.howToUse": " How to use",
  "Guide.nav.inspiration": "Inspiration",
  "Guide.nav.rejectedReasons": "Guide to Reject Reasons",
  "Guide.nav.channel": "Channel",
  "Guide.nav.selectTags": "How to Select Tags",

  //0.5 Common part(still image sticker & animated sticker)
  "Guide.caution": "Caution",
  "Guide.caution.description":
    "Please submit characters using personal creation or gained licenses.<br/>(You may upload content that is repurposed from copyright that you own.)",
  "Guide.thumbnail": "Thumbnail",
  "Guide.format": "Format",
  "Guide.size&margin": "Size",
  "Guide.size&margin.description":
    "- Make sure that the size of the sticker is 618 x 618 px.\n- The image file size should not exceed 500KB.",
  "Guide.size&margin.example": "Example :",
  //formt table text(common part-still image sticker & animated sticker)
  "Guide.thumbnailTable.format": "Format",
  "Guide thumbnailTable.format.data": "PNG",
  "Guide.thumbnailTable.size": "Size",
  "Guide.thumbnailTable.size.data": "250 x 250 (px)",
  "Guide.formatTable.format": "Format",
  "Guide.formatTable.format.data": "GIF", //only aminated sticker
  "Guide.formatTable.background": "Background",
  "Guide.formatTable.background.data": "Transparent",
  "Guide.formatTable.resolution": "Resolution",
  "Guide.formatTable.colorMode": "Color Mode",
  "Guide.formatTable.colorMode.data": "RGB (Recommend)",
  //size&margins table text(common part-still image sticker & animated sticker)
  "Guide.sizeTable.dimensions": "Dimensions",
  "Guide.sizeTable.margins": "Margins",
  "Guide.sizeTable.margins.data": "20px on all sides",
  "Guide.sizeTable.size": "Size",
  "Guide.sizeTable.size.data": "Not more than 500KB",
  //frequent mistakes
  "Guide.frequentMistakes": "Frequent mistakes!",
  "Guide.frequentMistakes.fitSize":
    "<p>Make stickers visible in all<br>mobile environments!</p>If the sticker is too small or too complex,<br/> it might not be visible.",
  "Guide.frequentMistakes.background":
    "<p>Please make the sticker's<br>background transparent!</p>Your sticker may include a background if necessary,<br/> but please delete any unnecessary background that is not<br>related to the sticker’s concept.",
  "Guide.frequentMistakes.fillInColor":
    "<p>Please fill in the surface of the sticker!</p>For stickers made using line drawing,<br/> fill the surface of the sticker with color.",
  "Guide.frequentMistakes.lowImageQuality":
    "<p>Increase the quality of the stickers!</p>Low-quality stickers can be difficult to see depending on<br>the mobile environment. Produce high-quality stickers<br>by matching resolution and size.",

  //1.Still Image Sticker
  "Guide.stillImageSticker.headline": "Still Image Sticker",
  "Guide.stillImageSticker.thumbnail.description":
    "clear margin of 20px on all sides.",
  "Guide.stillImageSticker.format.description":
    "If the pack type selected is Still Image Sticker, no file format other than PNG can be uploaded.",

  //2.Animated sticker
  "Guide.animatedSticker.headline": "Animated Sticker",
  "Guide.animatedSticker.thumbnail.description":
    "clear margin of 20px on all sides.",
  "Guide.animatedSticker.format.description":
    "If the pack type selected is Animated Sticker, no file format other than GIF can be uploaded.",
  "Guide.animatedSticker.frame": "Frame",
  "Guide.animatedSticker.frame.description":
    "- Please produce more than 2 frames and fewer than 15 frames.<br>- Set loop repeat to keep GIF playing.",
  "Guide.animatedSticker.frameTable.frame": "Frame",
  "Guide.animatedSticker.frameTable.frame.data": "Not more than 15 frames",
  "Guide.animatedSticker.frameTable.duration": "Duration",
  "Guide.animatedSticker.frameTable.duration.data": "Less than 2 seconds",

  "Guide.animatedSticker.saveCaution": "Settings when saving GIF stickers",
  "Guide.animatedSticker.saveCaution.description":
    "A white border may or may not appear around the sticker depending on the matte setting.<br/>When you’re selecting your matte setting in the GIF export settings, select between method 1・2.",
  "Guide.animatedSticker.saveCautionTable.dither": "Method 1",
  "Guide.animatedSticker.saveCautionTable.matteWhite": "Method 2",
  "Guide.animatedSticker.saveCautionTable.noMatte": "X",
  "Guide.animatedSticker.saveCautionTable.dither.data":
    "Matte > None\n“Diffusion Transparency Dither”",
  "Guide.animatedSticker.saveCautionTable.matteWhite.data":
    "Matte > White\n(White Recommended)",
  "Guide.animatedSticker.saveCautionTable.noMatte.data":
    "Matte > None\n“No Transparency Dither”",

  //3.How To Use
  "Guide.howToUse.headline": "How to use",
  "Guide.howToUse.headline.basicPack": "Basic Pack",
  "Guide.howToUse.headline.plusPack": "Plus Pack",
  "Guide.howToUse.definition.BASIC": "What is a Basic Pack",
  "Guide.howToUse.definition.PLUS": "What is a Plus Pack",
  "Guide.howToUse.definition.BASIC.desc.1":
    "1. You can submit a single sticker! (Each pack may contain at least 1 but fewer<br>than 24 stickers)",
  "Guide.howToUse.definition.BASIC.desc.2":
    "2. Both animated stickers (GIF) and still image stickers (PNG) are accepted.",
  "Guide.howToUse.definition.BASIC.desc.3":
    "3. The screening period and process are the same as the plus pack.",
  "Guide.howToUse.definition.BASIC.desc.4":
    "4. Once submitted, the pack type cannot be changed.",
  "Guide.howToUse.definition.PLUS.desc.1":
    "1. You need to submit a pack containing at least 24 stickers.",
  "Guide.howToUse.definition.PLUS.desc.2":
    "2. It can be sold on more channels.",
  "Guide.howToUse.definition.PLUS.desc.3":
    "3. Both animated stickers (GIF) and still image stickers (PNG) are accepted.",
  "Guide.howToUse.definition.PLUS.desc.4":
    "4. The screening period and process are the same as the plus pack.",
  "Guide.howToUse.definition.PLUS.desc.5":
    "5. Once submitted, the pack type cannot be changed.",
  "Guide.howToUse.subtitle.basicPack": "How to submit a Basic Pack",
  "Guide.howToUse.subTitle.basicPack.1": "1. Click Upload on the menu above.",
  "Guide.howToUse.subTitle.basicPack.2":
    "2. Please select the sticker type of Basic pack.",
  "Guide.howToUse.description.basicPack.2":
    "<span style='color: red'>*</span>Once submitted pack can't be modified so please submit it carefully.",
  "Guide.howToUse.subTitle.basicPack.3":
    "3.  Please enter the information of the pack you want to submit.",
  "Guide.howToUse.subTitle.basicPack.4":
    "4. Please upload the stickers for the pack you are submitting.",
  "Guide.howToUse.subTitle.basicPack.5":
    "5. Please select the tag and language of the sticker you are submitting.",
  "Guide.howToUse.subTitle.basicPack.6":
    "6.  If you have selected the tag and language for all stickers, please press the Submit Review button to complete the Basic Pack submission.",
  "Guide.howToUse.description.basicPack.6":
    "<span style='color: red'>*</span>Once submitted pack can't be modified so please submit it carefully.",
  "Guide.howToUse.subtitle.plusPack": "How to submit a Plus Pack",
  "Guide.howToUse.subTitle.plusPack.1": "1. Click Upload on the menu above.",
  "Guide.howToUse.description.plusPack.1":
    "<span style='color: red'>*</span>Once submitted pack can't be modified so please submit it carefully.",
  "Guide.howToUse.subTitle.plusPack.2":
    "2. Please select the sticker type of your Plus Pack.",
  "Guide.howToUse.subTitle.plusPack.3":
    "3. Please enter the information and language of the pack you want to submit.",
  "Guide.howToUse.description.plusPack.3":
    '<span style="color: red">*</span>All text in the pack must be in one language.',
  "Guide.howToUse.subTitle.plusPack.4":
    "4. Please upload at least 24 stickers for the pack you are submitting.",
  "Guide.howToUse.subTitle.plusPack.5":
    "5. Please select the tag and language of the sticker you are submitting.",
  "Guide.howToUse.subTitle.plusPack.6":
    "6. If you have selected the tag and language for all stickers, please press the Submit Review button to complete the Plus Pack submission.",
  "Guide.howToUse.description.plusPack.6":
    "<span style='color: red'>*</span>Once submitted pack can't be modified so please submit it carefully.",

  "Guide.howToUse.createPkgRequirement.title":
    "⚠️Mandatory when creating a pack",

  "Guide.howToUse.createPkgRequirement.title.image": "<strong>Image</strong>",

  "Guide.howToUse.createPkgRequirement.imageTable.numberTitle": "Number",
  "Guide.howToUse.createPkgRequirement.imageTable.sizeTitle": "Image size(px)",

  "Guide.howToUse.createPkgRequirement.imageTable.pkgImg":
    "<strong>Pack Thumbnail</strong>",
  "Guide.howToUse.createPkgRequirement.imageTable.pkgImg.number": "One",
  "Guide.howToUse.createPkgRequirement.imageTable.pkgImg.size":
    "250x250(px) PNG file with 72dpi resolution,<br/> less than 500KB",

  "Guide.howToUse.createPkgRequirement.imageTable.stickerImg":
    "<strong>Sticker Image</strong>",
  "Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number":
    "At least one, no maximum<br/>number of images",
  "Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number.basic":
    "At least one, fewer than<br/>24 stickers",
  "Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number.plus":
    "At least<br/> 24 stickers",
  "Guide.howToUse.createPkgRequirement.imageTable.stickerImg.size":
    "Image of 500KB or less, resolution of<br>72dpi, 618*618 (px) (detailed guide selects<br>the type of sticker from the left menu)",

  "Guide.howToUse.createPkgRequirement.textTable": "<strong>Text</strong>",

  "Guide.howToUse.createPkgRequirement.textTable.languageTitle": "Language",
  "Guide.howToUse.createPkgRequirement.textTable.charactersTitle":
    "The number of characters",

  "Guide.howToUse.createPkgRequirement.textTable.pkgName":
    "<strong>Pack Name</strong>",
  "Guide.howToUse.createPkgRequirement.textTable.pkgName.language":
    "English required",
  "Guide.howToUse.createPkgRequirement.textTable.pkgName.characters":
    "At least three characters",

  "Guide.howToUse.createPkgRequirement.textTable.pkgDescription":
    "<strong>Pack Description</strong>",
  "Guide.howToUse.createPkgRequirement.textTable.pkgDescription.language":
    "English required",
  "Guide.howToUse.createPkgRequirement.textTable.pkgDescription.characters":
    "No maximum number of characters",

  //4.inspiration
  "Guide.inspiration.headline": "Inspiration",
  "Guide.inspiration.kakao.title": "🏅Kakao popular creators' emoticon",
  "Guide.inspiration.kakao.description":
    "Save the Kakao Talk emoticon, coupon event, gift giving Kakao Friends emoticon, and purchase Kakao Talk emoticon in an emoticon shop!",

  "Guide.inspiration.line.title": "🏅Line popular creator’s sticker",
  "Guide.inspiration.line.subtitle":
    "LINE creators' stickers – Latest hit stickers | LINE STORE",
  "Guide.inspiration.line.description":
    "LINE STORE is LINE's official online store. You'll find all kinds of cute and oddly cuddly creator's stickers available for purchase, as well as handy stickers featuring celebrities and fun phrases.",

  "Guide.inspiration.facebook.title": "🏅Facebook Sticker Store",
  "Guide.inspiration.facebook.subtitle": "Sticker Store",
  "Guide.inspiration.facebook.description":
    "Find new stickers to send to friends.",

  "Guide.inspiration.telegram.title": "🏅Telegram Stickers Catalogue",
  "Guide.inspiration.telegram.subtitle": "Weekly top of Telegram stickers",
  "Guide.inspiration.telegram.description":
    "Weekly top of Telegram stickers. Best stickers of Telegram.",

  "Guide.inspiration.viber.title": "🏅Viber Sticker Market",
  "Guide.inspiration.viber.subtitle": "StickerMarket | Viber",
  "Guide.inspiration.viber.description":
    "Viber's Sticker Market. Download free, new, collections stickers.",

  //5.Channel
  "Guide.channel.headline": "Channel",
  "Guide.channel.tabs.service": "Service",
  "Guide.channel.tabs.test": "Test",

  //1)service tab
  "Guide.channel.service.mojitok.title":
    "Meet Mojitok on the App Store & Play Store.",
  "Guide.channel.service.mojitok.explain":
    "1) Open the mojitok app.<br/>2) Type in the discover menu to see recommended stickers.<br/>3) Use the recommended sticker on Whatsapp/Telegram/iMessage.",

  "Guide.channel.service.mojitok.galaxy.title":
    "Meet mojitok on the Galaxy Keyboard.",
  "Guide.channel.service.mojitok.galaxy.explain":
    "1) Open the Galaxy keyboard on your Galaxy  S10, Note 10/10+.<br/>2) Click on the sticker icon.<br/>3) Click on the mojitok icon.<br/>4) Press 'Download mojitok' to use mojitok on the Galaxy keyboard.",
  "Guide.channel.service.mojitok.galaxy.caution":
    "* It will soon be updated for all Galaxy devices.",

  "Guide.channel.service.fbExtension.title":
    "Meet Mojitok on Facebook Messenger.",
  "Guide.channel.service.fbExtension.explain":
    "1) Search for mojitok on Facebook Messenger App.<br/>2) Click 'Get Started' button and then 'Use Messenger Extension'.<br/>3) You can use the mojitok extension by pressing the + button when you are talking to your friends.",

  "Guide.channel.service.globalFriend.title": "Meet Mojitok on Global Friend.",
  "Guide.channel.service.globalFriend.explain":
    "1) Download Global Friend from Play Store or App Store.<br/>2) Use mojitok when you chat with friends.<br/>3) Mojitok can also be used in posts or comments.",

  //2)test tab
  "Guide.channel.test.explain":
    "This feature is designed to demonstrate the function of mojitok<br/> before submitting your content.🕵🏻",

  // 6. How to Select Tags
  "Guide.selectTags.headline": "How to Select Tags",
  "Guide.selectTags.description":
    "Mojitok is a service that uses AI to analyze a user's message and recommend appropriate stickers. Tag input is crucial as Mojitok’s AI <strong>matches the sticker to the user's message based on the tag entered when uploading the sticker.</strong>",
  "Guide.selectTags.tagSelection.title": "Tag Selection",
  "Guide.selectTags.caution.title": "Things to Note When Selecting Tags",
  "Guide.selectTags.mistake.title.1":
    "Please only select tags for emotions, situations, etc, that can be inferred intuitively from the sticker!",
  "Guide.selectTags.mistake.title.2":
    "Don’t choose the tag based on the emotion of the person who sees the sticker!",
  "Guide.selectTags.mistake.title.3":
    "If there is text in the sticker, please only select tags that correspond to the text!",
  "Guide.selectTags.mistake.title.4":
    "You don't have to choose a tag for a background that is not crucial to the sticker!",
  "Guide.selectTags.mistake.description.1":
    "All you have to do is select tags related to emotions, situations, etc, that are obvious in the sticker.<br/>You should not have to infer something hidden in <br/>the sticker to choose your tags!",
  "Guide.selectTags.mistake.description.2":
    "Often, the emotion of the person who receives the <br/>sticker is chosen, instead of the emotion expressed by <br/>the sticker itself. Please only select tags that the sticker shows, not tags for hidden emotions or future actions.",
  "Guide.selectTags.mistake.description.3":
    'If the sticker contains text that indicates the situation <br/>or emotion of the sticker, such as "Hi", "Ok", or "Good", please only select tags that directly correspond to the text.',
  "Guide.selectTags.mistake.description.4":
    "You can select tags for surrounding elements related to the main subject of the sticker. However, you don't <br/>have to choose a tag for a background that is not <br/>related to the sticker's actions or emotions.",

  /* UnapprovedCause.js */
  "UnapprovedCause.headline": "Guide to Reject Reasons",
  "UnapprovedCause.caution":
    "Please check the Rejection Guide carefully before submitting your content.<br/>Deployment may be interrupted if this is the case in the Reject Reasons after approval.<br/>In addition, distribution may be stopped if it does not fall under the Rejection Guide but is<br>deemed inappropriate. If your content includes pictures, you can also be requested a proof<br>of use document for those pictures.<br>(update 2020.12.11.)",

  "UnapprovedCause.A.title": "Non-compliance with the content guidelines below",
  "UnapprovedCause.A.causes.1":
    "If there is no margin for the sticker (20 px), approval will not be granted.",
  "UnapprovedCause.A.causes.2":
    "If the sticker is too small for the standard, It will not be approved.",
  "UnapprovedCause.A.causes.3":
    "If the side of the sticker is not filled with color, It will not be approved.",
  "UnapprovedCause.A.causes.4":
    "If a sticker does not require a background, but is not transparent,<br> It will not be approved.",
  "UnapprovedCause.A.causes.5":
    "If the quality of the sticker is too poor, It will not be approved.",
  "UnapprovedCause.A.causes.6":
    "If the GIF loop is not set repeatedly, It will not be approved.",
  "UnapprovedCause.A.causes.7":
    "If GIF loop is unnatural, It will not be approved.",
  "UnapprovedCause.A.causes.8":
    "If it has been determined that the visibility of the mobile environment is not<br> sufficient, It will not be approved.",
  "UnapprovedCause.A.causes.9":
    "If there is a spelling error within the sticker, the sticker will not be approved.",
  "UnapprovedCause.A.causes.10":
    "If you upload a sticker in a different format from the type of sticker you chose,<br> it will not be approved.",

  "UnapprovedCause.B.title":
    "Non-compliance with the tag and language selection guide",
  "UnapprovedCause.B.subtitle.1": "Non-compliance with the tag guide",
  "UnapprovedCause.B.subtitle.1.cause.1":
    "If the selected tag does not match the emotions and situations shown by the<br> sticker, it is not approved.",
  "UnapprovedCause.B.subtitle.2": "Non-compliance with the language guide",
  "UnapprovedCause.B.subtitle.2.cause.1":
    "If the language selection of the sticker is wrong, it is not approved.",

  "UnapprovedCause.C.title":
    "If the commercialization criteria are not met below",
  "UnapprovedCause.C.causes.1":
    "If merchandise is inappropriate in terms of visualization and usability of the<br> content, It will not be approved.",
  "UnapprovedCause.C.causes.2":
    "If any case take in place cause damage to the Sticker Farm brand image,<br> It will not be approved.",
  "UnapprovedCause.C.causes.3": "Duplicate content will not be approved.",
  "UnapprovedCause.C.causes.4":
    "If the image does not add value to a conversation, it will not be approved.",

  "UnapprovedCause.D.title": "Registers the same content as other platforms",
  "UnapprovedCause.D.causes.1":
    "If you have registered the same content as other platforms,<br> It will not be approved.",

  "UnapprovedCause.E.title": "Moral and ethical deficiencies",
  "UnapprovedCause.E.causes.1":
    "If you register content such as crime, sensational expression, abusive language<br> or speech, It will not be approved.",
  "UnapprovedCause.E.causes.2":
    "If you have registered content that may cause social controversy,<br> It will not be approved.",
  "UnapprovedCause.E.causes.3":
    "If you register content that promotes smoking, It will not be approved.",
  "UnapprovedCause.E.causes.4":
    "If you register content that contains anti-social content, It will not be approved.",
  "UnapprovedCause.E.causes.5":
    "If content is registered that may cause discomfort to a particular region, country,<br> religion, culture, group, etc, It will not be approved.",

  "UnapprovedCause.F.title":
    "Copyright, Portrait Rights Violation and Plagiarism",
  "UnapprovedCause.F.causes.1":
    "If you register content that may infringe someone else's product or plagiarized<br> copyright or portrait rights, It will not be approved.",
  "UnapprovedCause.F.causes.2":
    "If you register content that could cause any violates your trademark,<br> It will not be approved.",
  "UnapprovedCause.F.suffixRefer":
    "For more information on copyrights and trademarks, see the Korean Copyright<br> Commission, Patent Office, and Trademark Search Site.",

  "UnapprovedCause.G.title":
    "Proposals such as promoting business and advertising",
  "UnapprovedCause.G.prefixRefer":
    "For business advertising and promotional purposes, please contact<br> mojitok@platfarm.net.",
  "UnapprovedCause.G.causes.1":
    "If you provide content to a third party or register content created for the service<br> or advertising / promotion, It will not be approved.",
  "UnapprovedCause.G.causes.2":
    "If your company has registered content designed for advertising or promotion of<br> your brand or service, It will not be approved.",
  "UnapprovedCause.G.causes.3":
    "If you register content by collaboration between individuals and companies,<br> It will not be approved.",
  "UnapprovedCause.G.causes.4":
    "If you have registered content that contains promotional text,<br> It will not be approved.",
  "UnapprovedCause.G.causes.5":
    "If you have registered content that contains political elements,<br> It will not be approved.",

  "UnapprovedCause.H.title": "Pack Guide Not Compliant",

  "UnapprovedCause.H.subtitle.1": "Pack Thumbnail Guide Not Compliant",
  "UnapprovedCause.H.subtitle.1.causes.1":
    "If the thumbnail image contains an unrelated background that is not associated<br> with the design concept, the approval will not be granted.",
  "UnapprovedCause.H.subtitle.1.causes.2":
    "If the pack thumbnail is not associated with a sticker within the pack, approval<br> will not be granted.",
  "UnapprovedCause.H.subtitle.1.causes.3":
    "Copyright, plagiarism, and infringement of portrait rights on pack thumbnails<br> are not authorized.",
  "UnapprovedCause.H.subtitle.1.causes.4":
    "If a pack thumbnail is assessed to be less readable on mobile,<br> it will not be approved.",
  "UnapprovedCause.H.subtitle.1.causes.5":
    "Pack thumbnails will not be approved if they contain morally and ethically<br> unsuitable content.",
  "UnapprovedCause.H.subtitle.1.causes.6":
    "Pack thumbnails must be still images(PNG form). If an animated(GIF form) image<br> is uploaded, it will not be approved.",

  "UnapprovedCause.H.subtitle.2": "Pack Information Guide Not Compliant",
  "UnapprovedCause.H.subtitle.2.causes.1":
    "If the pack title contain words that are morally and ethically unsuitable, approval<br> will not be granted.",
  "UnapprovedCause.H.subtitle.2.causes.2":
    "If the description contain words that are morally and ethically unsuitable,<br> approval will not be granted.",

  "UnapprovedCause.H.subtitle.3": "Compliance with pack rules",
  "UnapprovedCause.H.subtitle.3.causes.1":
    "If the minimum requirements are not met or the pack information is inaccurate<br> when creating the pack, it will not be approved.",

  /* Mypage.js */
  //0. mypage navigation
  "Mypage.nav.setting": "Setting",
  "Mypage.nav.myPackage": "My Pack",
  "Mypage.nav.remittance-info": "Remittance Info",
  "Mypage.nav.remittance-request": "Remittance Request",

  //1. Setting
  "Mypage.setting.headline": "Setting",
  "Mypage.setting.subTitle.email": "Email",
  "Mypage.setting.subTitle.name": "Name/Nickname",
  "Mypage.setting.subTitle.country": "Choose a Country",
  "Mypage.setting.subTitle.commenderCode": "Commender Code",
  "Mypage.setting.subTitle.sns": "Add a Website",
  "Mypage.setting.descriptoin.sns":
    "Please add some sites to show your artworks<br/><p>*</p>Channels that are not related to creative activities may not be shown.",
  "Mypage.setting.validUrl.error": "This website is not valid.",
  "Mypage.setting.btn": "Save",

  /** My Package.js  */
  "MyPackage.headline": "My Pack",
  "Mypage.pkg.tab.all": "All",
  "Mypage.pkg.tab.approved": "Released",
  "Mypage.pkg.tab.editing": "Editing",
  "Mypage.pkg.tab.underReview": "Pending",
  "Mypage.pkg.tab.creating": "Creating",
  "Mypage.pkg.tab.unapproved": "Rejected",

  //2. Credit
  "Mypage.credit.headline": "Remittance Information",
  "Mypage.credit.subTitle": "Remittable Revenue",

  "Mypage.credit.invoice.title": "Remittance Details",
  "Mypage.credit.invoice.date": "Date",
  "Mypage.credit.invoice.amount": "Amount",
  "Mypage.credit.invoice.remittanceStatus": "Remittance Status",
  "Mypage.credit.invoice.tableNotData": "No application details.",
  "Mypage.credit.invoice.remittance.waitng": "Remittance Waitng",
  "Mypage.credit.invoice.remittance.completion": "Completion",

  //3. Payouts
  "Payouts.headline": "Remittance Request",

  "Payouts.select.account":
    "Please select an account to receive the remittance.",
  "Payouts.select.account.explain":
    "(You can request a remittance starting with a revenue of $100 or more.)",

  "Payouts.radio.other": "International (PayPal)",
  "Payouts.radio.korean": "Korean",
  "Payouts.radio.vietnamese": "Vietnamese",

  "Payouts.confirm.cancelText": "Check the Remittable Revenue",
  "Payouts.confirm.message":
    "<b>Insufficient Remittable Revenue</b><div>You can request a remittance when<br/>the remittable revenue is $100 or more.</div>",
  "Payouts.popover.btn":
    " You can apply starting <br/>&emsp; at $100 or higher.",
  "Payouts.korean.guide.phrase":
    "If you are Korean, Please choose Korean instead of PayPal.",

  "Payouts.btn": "Remittance Request",
  "Payouts.check.apply":
    "Please make sure to check the following before requesting the remittance.",

  "Payouts.collapse.header.korean": "If you have a Korean account",
  "Payouts.collapse.korean":
    "In Korea, you need to enter your name, e-mail, account number and resident<br/> registration number of the bank.<br/>Email must be entered using the e-mail you subscribed to.",
  "Payouts.collapse.header.vietnamese": "If you have a Vietnamese account",
  "Payouts.collapse.vietnamese":
    "In Veitnam, you need to enter the name of the beneficiary, <br/>the tax code and the account information.<br/>It is the individual's responsibility to pay personal income tax.<br/><br/>Email must be entered using the e-mail you subscribed to.",
  "Payouts.collapse.header.other": "International (If you use PayPal)",
  "Payouts.collapse.other":
    "You can use PayPal’s Premier or Business Account.<br/><br/>First, you need PayPal ID.<br/>Register your account on the PayPal site.<br/><br/>In addition, the email in the stickerfarm account must be the same as the email in the PayPal account.<br/>If not, check the PayPal site for ways to add email.<br/><br/>PayPal fees apply. <br/>To learn more about fees, please visit the fees page for your country.<br/><br/>※ You can not use your personal account. <br/>     Please check PayPal for the type of PayPal account.<br/><br/>※ Please make sure your PayPal account can receive U.S dollars.<br/><br/>※ You can not register with PayPal account if you are living in Korea.",

  //1.Payout - korea
  "PayoutsForm.korean.headline": "Remittance Request (KOREA)",
  "PayoutsForm.form.name": "Name:",
  "PayoutsForm.form.email": "E-mail:",
  "PayoutsForm.form.email.explain": "* Enter subscribed E-mail",
  "PayoutsForm.form.account": "Account:",
  "PayoutsForm.form.registNumber": "Resident registration number :",
  "PayoutsForm.form.registNumber.explain":
    "* You must enter the resident registration number of the account holder.",
  "PayoutsForm.form.address": "Address :",
  "PayoutsForm.form.zoneCode.btn": "Seach for Postal Code",
  "PayoutsForm.form.payment.amount.request":
    "Amount of requesting remittance ($) :",
  "PayoutsForm.request.btn": "Complete Requesting Remittance",

  //messages
  "PayoutsForm.form.name.error.required": "Name is required",
  "PayoutsForm.form.email.error.required": "Email is required",
  "PayoutsForm.form.email.error.type": "Email is not a valid email",
  "PayoutsForm.form.accountBank": "Please select a bank",
  "PayoutsForm.form.bankDefault": "Bank",
  "PayoutsForm.form.accountNumber": "Account number",
  "PayoutsForm.form.accountNumber.error.required": "Account number is required",
  "PayoutsForm.form.accountNumber.error.type":
    "Account number is not a valid Account Number",
  "PayoutsForm.form.accountName": "A deposit",
  "PayoutsForm.form.accountName.error.required": "A deposit is required",
  "PayoutsForm.form.registNumFront": "YYMMDD",
  "PayoutsForm.form.registNumFront.error.required":
    "Resident registration number is required",
  "PayoutsForm.form.registNumFront.error.type":
    "Resident registration number is not valid number",
  "PayoutsForm.form.registNumBack.error.required":
    "Resident registration number is required",
  "PayoutsForm.form.registNumBack.error.type":
    "Resident registration number is not valid number",
  "PayoutsForm.form.zoneCode.error.required": "Please search the address",
  "PayoutsForm.form.detailAddress": "Remaining address",
  "PayoutsForm.form.payment.request.error.required":
    "Payment amount is required",
  "PayoutsForm.form.payment.request.error.type":
    "You can apply in dollar increments from the amount of more than $100.",
  "PayoutsForm.form.payment.request.notMatchEmail":
    "E-mail does not match the one you joined.",
  "PayoutsForm.form.payment.request.failed":
    "Credit is not available for application. Please check it.",
  "PayoutsForm.form.payment.request.mail.success": "Request Success",
  "PayoutsForm.form.payment.request.mail.error": "Error! Please try again",

  //bank
  "PayoutsForm.korean.form.account.bank.NH": "NH Bank",
  "PayoutsForm.korean.form.account.bank.KB": "KB Bank",
  "PayoutsForm.korean.form.account.bank.Shinhan": "Shinhan Bank",
  "PayoutsForm.korean.form.account.bank.Woori": "Woori Bank",
  "PayoutsForm.korean.form.account.bank.Hana": "KEB Hana Bank",
  "PayoutsForm.korean.form.account.bank.IBK": "IBK Bank",
  "PayoutsForm.korean.form.account.bank.SC": "Standard Charterd (SC)",
  "PayoutsForm.korean.form.account.bank.Citi": "Citibank",
  "PayoutsForm.korean.form.account.bank.KDB": "KDB Bank",
  "PayoutsForm.korean.form.account.bank.ACU": "Agricultural Cooperation Unit",
  "PayoutsForm.korean.form.account.bank.Daegu": "Daegu Bank",
  "PayoutsForm.korean.form.account.bank.Kwangju": "Kwangju Bank",
  "PayoutsForm.korean.form.account.bank.KoreaPost": "Korea Post Office",
  "PayoutsForm.korean.form.account.bank.Shinhyup":
    "National Credit Union Federation of Korea",
  "PayoutsForm.korean.form.account.bank.Jeonbuk": "Jeonbuk Bank",
  "PayoutsForm.korean.form.account.bank.Kyongnam": "Kyongnam Bank",
  "PayoutsForm.korean.form.account.bank.Busan": "Busan Bank",
  "PayoutsForm.korean.form.account.bank.Suhyup": "Suhyup Bank",
  "PayoutsForm.korean.form.account.bank.Jeju": "Jeju Bank",
  "PayoutsForm.korean.form.account.bank.Kakao": "Kakao Bank ",
  "PayoutsForm.korean.form.account.bank.HSBC": "HSBC",
  "PayoutsForm.korean.form.account.bank.ICBC": "ICBC",
  "PayoutsForm.korean.form.account.bank.JP": "JP Morgan",
  "PayoutsForm.korean.form.account.bank.Deutsche": "Deutsche Bank",
  "PayoutsForm.korean.form.account.bank.BNP": "BNP Paribas",
  "PayoutsForm.korean.form.account.bank.BOA": "Bank of America",
  "PayoutsForm.form.payment.credit": "Remittable Revenue : ",

  //2.Payouts-vietnam
  "PayoutsForm.vietnam.headline": "Remittance Request (VIETNAM)",
  "PayoutsForm.vietnam.form.name.explain": "* Enter name of payment recipient",
  "PayoutsForm.vietnam.form.taxPaymentCode.error.required":
    "Tax payment code is required",
  "PayoutsForm.vietnam.form.taxPaymentCode": "Tax payment code :",

  //3.Payouts-PayPal
  "PayoutsForm.paypal.headline": "Remittance Request (PAYPAL)",

  /* FAQ.js */
  "FAQ.headline": "FAQ",
  // FAQ - menu
  "FAQ.menu.suggestion": "Suggestion",
  "FAQ.menu.registration": "Registration",
  "FAQ.menu.distribution": "Distribution",
  "FAQ.menu.credit": "Revenue",

  // FAQ - subTitle
  "FAQ.subtitle.suggestion": "Suggestion",
  "FAQ.subtitle.registration": "Registration",
  "FAQ.subtitle.distribution": "Distribution",
  "FAQ.subtitle.revenue": "Revenue",

  //FAQ - collapse title(Panel header)
  "FAQ.collapse.suggestion.title.1":
    "I would like to know the detailed conditions for registering a stickers.",
  "FAQ.collapse.suggestion.title.2":
    "Are there any precautions when registering stickers?",
  "FAQ.collapse.suggestion.title.3":
    "Is there any size or number of stickers suggested?",
  "FAQ.collapse.suggestion.title.4":
    "What are the differences between basic pack and plus pack?",
  "FAQ.collapse.suggestion.title.5":
    "How long will it take to review the sticker proposal of plus pack and basic pack?",
  "FAQ.collapse.registration.title.1":
    "Is it possible to re-upload existing stickers as plus pack?",
  "FAQ.collapse.registration.title.2":
    "I uploaded basic pack, can I change it to a plus pack with more stickers?",
  "FAQ.collapse.registration.title.3":
    "Can stickers of various languages be uploaded to plus packs like basic packs?",
  "FAQ.collapse.registration.title.4":
    "Can pack information be entered in English only?",
  "FAQ.collapse.registration.title.5": "Is it possible to delete packs?",
  "FAQ.collapse.registration.title.6": "Is emotional tag selection mandatory?",
  "FAQ.collapse.distribution.title.1":
    "Will approved packs be distributed immediately?",
  "FAQ.collapse.distribution.title.2":
    "I'd like to know why you didn't approve the sticker.",
  "FAQ.collapse.distribution.title.3":
    "Where is the sticker from which the distribution started?",
  "FAQ.collapse.revenue.title.1":
    "When the pack is distributed, does the creator receive a sales revenue?",
  "FAQ.collapse.revenue.title.2": "When will the revenue be remitted?",
  "FAQ.collapse.revenue.title.3": "How do I enter my remittance information?",
  "FAQ.collapse.revenue.title.4": "What currency is the revenue remittance in?",
  "FAQ.collapse.revenue.title.5":
    "Can I specify where to receive my revenue remittance?",
  "FAQ.collapse.revenue.title.6":
    "Is there a country that can not receive revenue remittance?",

  //FAQ - Panel
  //suggestion
  "FAQ.collapse.suggestion.explain.1":
    "Stickerfarm can bring your stickers to anyone!<br/>Try it now!",
  "FAQ.collapse.suggestion.explain.2":
    "Please check the guide and work with it.<br/>Sticker suggestions can only be with content created or copyrighted by yourself.<br/><br/>※ To make a suggestion, please register your email account in a stickerfarm",
  "FAQ.collapse.suggestion.explain.3":
    "A minimum of one sticker is allowed.<br/>Please check the size guidelines before production of the sticker.",
  "FAQ.collapse.suggestion.explain.4":
    "Basic pack can be created with one sticker. plus pack requires an upload of at least 24 stickers. In addition, plus pack have more opportunities to generate revenue than basic pack.",
  "FAQ.collapse.suggestion.explain.5":
    "The sticker review period is from 4 days to up to 2 weeks. Basic pack and plus pack go through the same screening process and period.",

  //registration
  "FAQ.collapse.registration.explain.1":
    "Sticker packs already on Stickerfarm may not be reuploaded as plus pack.",
  "FAQ.collapse.registration.explain.2":
    "No, the type of pack you set when uploading the sticker cannot be changed.",
  "FAQ.collapse.registration.explain.3":
    "No, plus packs can only contain stickers of one language per pack.",
  "FAQ.collapse.registration.explain.4":
    "The pack information input is recommended to use English. If you need to input pack information in other languages, you can add it by pressing the 'add language' button.",
  "FAQ.collapse.registration.explain.5":
    "As sticker distribution and usage is immediately reflected in your earnings once submission is approved, packs and stickers within packs cannot be deleted after submission.",
  "FAQ.collapse.registration.explain.6":
    "Selection of emotion tags is mandatory when submitting stickers.<br/>The stickers will be recommended based on the tags that you’ve chosen.<br/><br/>Please select a tag that is suitable for your sticker,<br/>such as a related emotion, situation, behavior, or object.<br/><br/>If an unsuitable tag is selected,<br/>your sticker may be rejected during evaluation.<br/>Please refer to the tag guide to select an appropriate one!",

  //distribution
  "FAQ.collapse.distribution.explain.1":
    "Stickers of the pack that passed the screening after the sticker proposal will be distributed immediately.",

  "FAQ.collapse.distribution.explain.2":
    'For reasons of non-authorization, please refer to <a href="/guide/rejectedReasons" target="_blank">“Guide to Reject Reasons.”</a>',

  "FAQ.collapse.distribution.explain.2.caution":
    "Even if any of the above guides doesn’t apply to your sticker, <br/>Stickerfarm can cease the sale of the sticker when it is judged inappropriate to be sold.",

  "FAQ.collapse.distribution.explain.3":
    "Stickers may be used on messaging services that have a contract with Stickerfarm to use content.<br/>The list of messaging services can be found on the “Channel” tab of the Guide menu.",

  //credit
  "FAQ.collapse.revenue.explain.1":
    "Revenue is updated monthly based on the Sales of packs and usage rate of each sticker.",
  "FAQ.collapse.revenue.explain.2":
    "You need a minimum of $100 in revenue in order to request a remittance.<br/>The creator's personal information entered in the remittance request is used only for remittance purposes and will be discarded after the remittance is complete.<br/>Revenue will be remitted to the registered payment account within 45 days of the request.<br/>(3.3% deduction)<br/><br/>If you submit a request before the 15th of the month, you will receive your revenue remittance by the end of that same month.<br/>Requests made after the 15th of every month will be processed by the end of the following month.<br/><br/>Request for remittance on 14 March - Remittance on 31 March<br/>Request for remittance on 16 March - Remittance on 30 April",
  "FAQ.collapse.revenue.explain.3":
    "You can register at “My Page”.<br/>The e-mail address must be the same as the e-mail address you signed up to stickerfarm.",
  "FAQ.collapse.revenue.explain.4": "It’s the U.S dollar.",

  "FAQ.collapse.revenue.explain.5.subtitle.1":
    "If you live in Korea or Vietnam",
  "FAQ.collapse.revenue.explain.5.subExplain.1":
    "- Financial institutions(banking and credit safe, etc.) are available in Korea and Vietnam.",
  "FAQ.collapse.revenue.explain.5.subtitle.2":
    "<br/>If you live outside of Korea and Vietnam",
  "FAQ.collapse.revenue.explain.5.subExplain.2":
    "- You can use PayPal’s Premier or Business Account.<br/><br/>※ You can not use your personal account. Please check PayPal for the type of PayPal account.<br/>※ Please make sure your PayPal account can receive U.S dollars.<br/>※ You can not register with PayPal account if you are living in Korea.",

  "FAQ.collapse.revenue.explain.6":
    "You can not get revenue remittance in countries or regions where PayPal is not available.<br/>Please check the PayPal remittance area.",

  /* ComingSoon.js */
  "ComingSoon.headline": "Coming Soon!",
  "ComingSoon.description":
    "The current page is preparing for service.<br/>Please wait a moment until you find me again with a quick service.",

  /* Report.js - report 페이지 완성 전까지 */
  "Report.title":
    '<span style="color:#a202ff;"> Hey, sticker…</span><br/>Are U doing well?',
  "Report.description":
    "Have you ever wondered how your precious stickers,<br/>the result of pain of creation, are now being used?<br/><br/>For now, Stickerfarm will solve your curiosities<br/>about your stickers.",

  "Report.ready.title":
    'So <span style="color:#a202ff;">stickerfarm</span> is now<br/>preparing something like this!',

  "Report.dashbard.title": "Dashboard",
  "Report.dashbard.description":
    "Meet the customized information board.<br/>It’s only for you!",

  "Report.stats.title": "Statistics Report",
  "Report.stats.description":
    "Activity history, best selling stickers, and even about credits! Check out every data with the Statistics report.",

  "Report.cheering.message":
    "If you are looking forward of stickerfarm’s new page,<br/><strong>👇Press the heart button below</strong>👇",
  "Report.cheering.message.push":
    "<strong>👆for cheer-up-message to stickerfarm!👆</strong>",

  "Report.nav.dashboard": "Dashboard",
  "Report.nav.ranking": "Ranking",
  "Report.nav.revenue": "Revenue",

  /**Report / Revenue.js */
  "Report.revenue.headline": "Revenue",
  "Report.revenue.revenueReport": "Revenue Report",
  "Report.revenue.monthlyRevenue": "Revenue in {month}",
  "Report.revenue.accumulationRevenue": "Total Revenue",
  "Report.revenue.monthlyRevenueTrend": "Monthly Revenue",
  "Report.revenue.last12months": "Last 12 Months",

  /**Report / Dashboard.js */
  "Report.dashboard.headline": "Dashboard",
  "Report.dashboard.title.hello": "Hello!",
  "Report.dashboard.title.creator": "<p>Creator {creator}</p>",
  "Report.dashboard.guide.text": "Monthly Report Guide",
  "Report.dashboard.monthlyReport": "Monthly Report",
  "Report.dashboard.monthlyReport.guide":
    "Hover over the graph to see monthly Indexes.",
  "Report.dashboard.pointViewer.title": "{point} in {month}",
  "Report.dashboard.pointViewer.explain.viewPoint":
    "The View Index indicates <span class='tooltip-title-highlight'>how often<br/>your stickers appeared</span> in mojitok",
  "Report.dashboard.pointViewer.explain.sharePoint":
    "The Share Index indicates <span class='tooltip-title-highlight'>how many times<br/>users bought and sent your stickers</span> in mojitok",
  "Report.dashboard.pointViewer.explain.activityPoint":
    "The Activity Index indicates <span class='tooltip-title-highlight'>how active<br/>you have been</span> on Stickerfarm",

  "Report.dashboard.noData.explain.title":
    "Thanks for joining Stickerfarm, {creator}!",
  "Report.dashboard.noData.explain.description":
    "Sorry, you don’t have sufficient activity on Stickerfarm to calculate Indexes yet.😢<br/>You may check records of your hard work at Stickerfarm with View/Share/Activity Indexes.",
  "Report.dashboard.noData.explain.guide":
    "Your View/Share/Activity Indexes for each month will be released in the second week of the following month.",

  /*CheckPolicy.js*/
  "CheckPolicy.checkbox.title": "I have read the Terms and Conditions",
  "CheckPolicy.noti.check":
    "Please read and agree to the Terms and Conditions 📝",
  "CheckPolicy.agreeBtn": "Agree",

  /*페이지 상관없이 사용되는 에러 메세지들 */
  "ErrorMessage.noLanguageSelected":
    "No language selected.\n Please choose other language.",
  "ErrorMessage.noStickersInPkg":
    "You haven’t added any stickers.🤯&nbsp;&nbsp;&nbsp;Please add at least one sticker.",
};
